import {Path, Svg} from 'react-native-svg';

const NavigationIcon = ({isActive = false, color = '#202020'}: {isActive?: boolean; color?: string}) => (
  <Svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <Path
      d="M1.94446 8.63158L15.5556 2L9.10824 16L7.67548 10.1053L1.94446 8.63158Z"
      fill={color}
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default NavigationIcon;
